import {
  GET_ORDER_REQ_SUCCESS,
  SAVE_ORDER_DATA_SUCCESS,
  GET_ORDER_SUCCESS
} from "../../actions/orderActions";
import { GET_EVENT_SUCCESS } from "../../actions/eventActions";
import { GET_GIFT_CARD_PAGE_SUCCESS } from "../../actions/giftCardActions";

import { constructRouteStack } from "../../actions/routingActions";

const actionMapper = {
  [GET_ORDER_REQ_SUCCESS]: constructRouteStack,
  [GET_EVENT_SUCCESS]: constructRouteStack,
  [SAVE_ORDER_DATA_SUCCESS]: constructRouteStack,
  [GET_ORDER_SUCCESS]: constructRouteStack,
  [GET_GIFT_CARD_PAGE_SUCCESS]: constructRouteStack
};

export const navigationPostHook = store => {
  const {
    lastAction: { type }
  } = store.getState();
  if (actionMapper[type]) {
    store.dispatch(actionMapper[type]());
  }
};
